import { DropdownButton, MenuItem } from "react-bootstrap";

type OwnProps = {
  title: string;
  icon: string;
  children?: React.ReactNode;
  disabled?: boolean;
};

const defaultProps: Partial<OwnProps> = {
  disabled: false,
  children: undefined,
};

type Props = OwnProps & typeof defaultProps;

function ActionDropdownButton({ children, title, icon, disabled }: Props) {
  const className = `btn-link btn-action ${icon}`;

  return (
    <div className="actionbar-dropdown">
      <DropdownButton
        disabled={disabled}
        id="dropdown_button"
        bsStyle="default"
        className={className}
        noCaret
        title={<span className="action-button-label hidden-xs">{title}</span>}
      >
        {children}
        <MenuItem className="close-item">
          <span className="icon icon-eh-show-less" />
        </MenuItem>
      </DropdownButton>
    </div>
  );
}

ActionDropdownButton.defaultProps = defaultProps;

export default ActionDropdownButton;
